/* Kanopi theme layer: gallery thumbnails and zoom, mobile sticky add-to-cart bar, carousels, quantity buttons. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initGallery(root) {
    if (root.dataset.kpReady) return;
    root.dataset.kpReady = '1';
    var track = root.querySelector('.kp-gallery__track');
    var thumbs = root.querySelectorAll('[data-kp-go]');
    var dialog = root.querySelector('[data-kp-zoom-dialog]');
    if (!track) return;
    function setCurrent(i) {
      thumbs.forEach(function (t) {
        if (String(t.dataset.kpGo) === String(i)) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var slide = track.querySelector('[data-index="' + t.dataset.kpGo + '"]');
        if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        setCurrent(t.dataset.kpGo);
      });
    });
    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)) + 1;
        setCurrent(i);
      }, 80);
    }, { passive: true });
    if (dialog && typeof dialog.showModal === 'function') {
      var img = dialog.querySelector('.kp-zoom__img');
      root.querySelectorAll('[data-kp-zoom]').forEach(function (b) {
        b.addEventListener('click', function () {
          img.src = b.dataset.kpZoom;
          img.alt = b.dataset.kpAlt || '';
          dialog.showModal();
        });
      });
      dialog.addEventListener('click', function (e) { if (e.target === dialog || e.target === img) dialog.close(); });
    }
  }

  function initSticky(bar) {
    if (bar.dataset.kpReady) return;
    bar.dataset.kpReady = '1';
    var form = document.getElementById(bar.dataset.kpSticky);
    if (!form || !('IntersectionObserver' in window)) return;
    var footer = document.querySelector('footer, .shopify-section-group-footer-group');
    var formVisible = true, footerVisible = false;
    function update() {
      var show = !formVisible && !footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) { bar.removeAttribute('inert'); } else { bar.setAttribute('inert', ''); }
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.target === form) {
          // Only hide the bar when the form is on screen or still below the fold at the top of the page.
          formVisible = e.isIntersecting || e.boundingClientRect.top > 0;
        } else {
          footerVisible = e.isIntersecting;
        }
      });
      update();
    }).observe(form);
    if (footer) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        update();
      }).observe(footer);
    }
  }

  function initCarousel(root) {
    if (root.dataset.kpReady) return;
    root.dataset.kpReady = '1';
    var track = root.querySelector('.kp-carousel__track');
    if (!track) return;
    root.querySelectorAll('[data-kp-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = track.querySelector('.kp-carousel__item');
        var step = item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
        track.scrollBy({ left: step * Number(btn.dataset.kpDir), behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  function initQty(scope) {
    scope.querySelectorAll('.kp-qty').forEach(function (q) {
      if (q.dataset.kpReady) return;
      q.dataset.kpReady = '1';
      var input = q.querySelector('input');
      q.querySelectorAll('[data-kp-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = (parseInt(input.value, 10) || 1) + Number(b.dataset.kpQty);
          input.value = Math.max(1, v);
        });
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-kp-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-kp-sticky]').forEach(initSticky);
    scope.querySelectorAll('[data-kp-carousel]').forEach(initCarousel);
    initQty(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
